import { render, staticRenderFns } from "./PurchaseProvideOtherInfo.vue?vue&type=template&id=421ee978&scoped=true&"
import script from "./PurchaseProvideOtherInfo.vue?vue&type=script&lang=js&"
export * from "./PurchaseProvideOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProvideOtherInfo.vue?vue&type=style&index=0&id=421ee978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ee978",
  null
  
)

export default component.exports